module.exports = __webpack_public_path__ + "img/10.d049a675.png";